import { Card, CardBody } from '@chakra-ui/react';
import React from 'react';

import { colors } from '~/packages/common-frontend/colors';
import { Typography } from '~/packages/common-frontend/components/Typography';
import { useSimpleColorMode } from '~/packages/common-frontend/theme/utils';

type PortfolioGridItemProps = {
  label: string;
  value?: string;
  isActive?: boolean;
  cursor?: string;
};
export const PortfolioGridItem = ({
  label,
  value = '-',
  isActive = false,
  cursor = 'default',
}: PortfolioGridItemProps) => {
  const mode = useSimpleColorMode();
  return (
    <Card
      variant="outline"
      borderColor={
        isActive ? mode(colors.gray[700], colors.gray[100]) : undefined
      }
      cursor={cursor}
    >
      <CardBody display="flex" flexDirection="column" gap="0.5rem">
        <Typography variant="detail-muted">{label}</Typography>
        <Typography fontWeight="semibold">{value}</Typography>
      </CardBody>
    </Card>
  );
};
